function getAttr(element, attr) {
    if (!element || !attr) {
        throw new Error('element or attribute not provided')
    }
    return $(element).attr(attr)
}
